import { TROUBLESHOOTING } from "./constants_v2.js";

const eventMap = {
  click: {},
  change: {},
  submit: {},
  pointerover: {},
  pointermove: {},
  pointerout: {},
  pointerdown: {},
  pointerup: {},
  keyup: {},
  keydown: {}, // chat: Ctrl+Enter to send
  contextmenu: {},
  resize: {},
  touchstart: {},
  touchmove: {},
  touchend: {},
  input: {},
  blur: {},
  focus: {},
};

const handlePinchZoom = (event) => {
  if (event.touches.length !== 2) return;
  // we do NOTHING here.
  // Because we want the browser to do native zoom
};

const getValidElement = (target) => {
  // If user clicked a text node, return the parent element instead
  if (target && target.nodeType === 3) {
    return target.parentElement;
  }
  return target;
};

const executeRegisteredHandler = (type, targetElement, event) => {
  // We need to climb up the tree from the click target
  // to see if ANY parent is registered in our eventMap
  let currentElement = targetElement;

  while (currentElement && currentElement !== document) {
    const elementId = currentElement.id;
    const action = currentElement.dataset.action;

    // 1. Check for data-action first
    if (action && eventMap[type][action]) {
      const handler = eventMap[type][action];
      handler(event, currentElement);
      return; // Stop searching once handled
    }

    // 2. Check for registered ID
    if (elementId && eventMap[type][elementId]) {
      const handler = eventMap[type][elementId];
      handler(event, currentElement);
      return; // Stop searching once handled
    }

    // Move up to the next parent to see if IT is registered
    currentElement = currentElement.parentElement;
  }
};

// --- Core Logic ---

const createListener = (type) => {
  return (event) => {
    // Specialized handling for Pinch to Zoom
    if (type === "touchmove" && event.touches.length === 2) {
      handlePinchZoom(event);
      return;
    }

    if (type === "submit") {
      event.preventDefault();
    }

    const element = getValidElement(event.target);
    if (element) {
      executeRegisteredHandler(type, element, event);
    }
  };
};

const registerEvent = (type, id, handler) => {
  if (eventMap[type]) {
    eventMap[type][id] = handler;
  } else {
    console.warn(`Event type "${type}" is not supported by eventHub`);
  }

  //  total count
  const totalHandlers = Object.values(eventMap).reduce(
    (total, typeObj) => total + Object.keys(typeObj).length,
    0,
  );

  const debugElement = document.getElementById("troubleshootingInfo4");
  if (debugElement && TROUBLESHOOTING) {
    debugElement.innerText = `Registered Handlers: ${totalHandlers}`;
  }
};

const initEventHub = () => {
  const types = Object.keys(eventMap);

  for (const type of types) {
    const listener = createListener(type);
    document.addEventListener(type, listener);
  }
};

export const eventHub = {
  registerEvent,
  initEventHub,
};
